import React from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from './routeConfig';

export function AppRoutes() {
  const allRoutes = useRoutes(routes);

  return <React.Fragment> {allRoutes} </React.Fragment>;
}

export { RouteScrollToTop } from './RouteScrollToTop';
